<div class="config-scroll-wrapper" [testId]="'system-config-scroll-wrapper'">
  <div class="config-container" [testId]="'system-config-container'">
    <nz-spin [nzSpinning]="configLoading" [testId]="'system-config-loading'">
      <form nz-form [formGroup]="configForm" class="config-form" [testId]="'system-config-form'">
        <nz-card
          *ngFor="let group of groupedConfigParams; let gIdx = index"
          class="config-card"
          [testId]="'system-config-card-' + (group.id || gIdx)"
        >
          <div class="card-header" [testId]="'system-config-card-header'">
            <h3 [testId]="'system-config-group-name'">{{ group.groupName }}</h3>
          </div>
          <nz-divider [testId]="'system-config-divider'" />
          <div nz-row [nzGutter]="24" [testId]="'system-config-form-row'">
            <div nz-col [nzSpan]="24" *ngFor="let param of group.params" [testId]="'system-config-form-col-' + (param.code || param.id)">
              <ng-container *ngIf="param.visible !== false">
                <nz-form-item [testId]="'system-config-form-item'">
                  <nz-form-label [nzSpan]="6" [nzRequired]="param.require" [testId]="'system-config-form-label'">
                    {{ param.name }}
                    <i
                      nz-icon
                      nzType="question-circle"
                      nzTheme="outline"
                      *ngIf="param.description"
                      nz-tooltip
                      [nzTooltipTitle]="param.description"
                      [testId]="'system-config-help-icon'"
                    ></i>
                  </nz-form-label>
                  <nz-form-control
                    [nzSpan]="18"
                    [nzErrorTip]="('system-config.please-enter' | i18n) + param.name"
                    [testId]="'system-config-form-control'"
                  >
                    <!-- 文本输入框 -->
                    <ng-container *ngIf="param.type === 'InputBox-Text'" [testId]="'system-config-text-input-container'">
                      <input
                        nz-input
                        [formControlName]="param.code"
                        [placeholder]="('system-config.please-enter' | i18n) + param.name"
                        [disabled]="param.disable"
                        [testId]="'system-config-text-input'"
                      />
                    </ng-container>

                    <!-- 数字输入框 -->
                    <ng-container *ngIf="param.type === 'InputBox-Integer'" [testId]="'system-config-number-input-container'">
                      <nz-input-number
                        [formControlName]="param.code"
                        [nzPlaceHolder]="('system-config.please-enter' | i18n) + param.name"
                        [nzDisabled]="param.disable"
                        style="width: 100%"
                        [testId]="'system-config-number-input'"
                      />
                    </ng-container>
                    <!-- 网址输入框 -->
                    <ng-container *ngIf="param.type === 'InputBox-Url'" [testId]="'system-config-url-input-container'">
                      <input
                        nz-input
                        [formControlName]="param.code"
                        [placeholder]="('system-config.please-enter' | i18n) + param.name + ('system-config.url-placeholder' | i18n)"
                        [disabled]="param.disable"
                        type="url"
                        [testId]="'system-config-url-input'"
                      />
                    </ng-container>

                    <!-- 下拉选择框 -->
                    <ng-container *ngIf="param.type === 'ComboBox-SelectOnly'" [testId]="'system-config-select-container'">
                      <nz-select
                        [formControlName]="param.code"
                        [nzPlaceHolder]="('system-config.please-select' | i18n) + param.name"
                        [nzDisabled]="param.disable"
                        style="width: 100%"
                        [testId]="'system-config-select'"
                      >
                        <nz-option
                          *ngFor="let option of getDictionaryOptions(param.dictionaryId)"
                          [nzValue]="option.value"
                          [nzLabel]="option.label"
                          [testId]="'system-config-select-option-' + option.value"
                        />
                      </nz-select>
                    </ng-container>

                    <!-- 开关 -->
                    <ng-container *ngIf="param.type === 'CheckBox'" [testId]="'system-config-switch-container'">
                      <nz-switch [formControlName]="param.code" [nzDisabled]="param.disable" [testId]="'system-config-switch'" />
                    </ng-container>

                    <!-- 日期选择器 -->
                    <ng-container *ngIf="param.type === 'DatePicker'" [testId]="'system-config-date-picker-container'">
                      <nz-date-picker
                        [formControlName]="param.code"
                        [nzDisabled]="param.disable"
                        style="width: 100%"
                        [testId]="'system-config-date-picker'"
                      />
                    </ng-container>

                    <!-- 文本域 -->
                    <ng-container *ngIf="param.type === 'TextBox'" [testId]="'system-config-textarea-container'">
                      <textarea
                        nz-input
                        [formControlName]="param.code"
                        [placeholder]="('system-config.please-enter' | i18n) + param.name"
                        [disabled]="param.disable"
                        [nzAutosize]="{ minRows: 3, maxRows: 5 }"
                        [testId]="'system-config-textarea'"
                      ></textarea>
                    </ng-container>
                    <!-- 在现有的ng-container条件判断中添加 -->
                    <ng-container *ngIf="param.type === 'InputBox-Avatar'" [testId]="'system-config-avatar-container'">
                      <div class="avatar-upload-container" [testId]="'system-config-avatar-upload-container'">
                        <div class="avatar-wrapper" [testId]="'system-config-avatar-wrapper'">
                          <div class="avatar-placeholder" *ngIf="!avatarUrls[param.code]" [testId]="'system-config-avatar-placeholder'">
                            <nz-icon nzType="user" nzTheme="outline" [testId]="'system-config-avatar-placeholder-icon'" />
                            <div class="placeholder-text" [testId]="'system-config-avatar-placeholder-text'">{{
                              'ystem-config.click-upload-avatar' | i18n
                            }}</div>
                          </div>
                          <img
                            *ngIf="avatarUrls[param.code]"
                            [src]="avatarUrls[param.code]"
                            class="avatar-image"
                            [testId]="'system-config-avatar-image'"
                          />
                          <div
                            class="avatar-upload-overlay"
                            (click)="showAvatarUploadModal(param.code)"
                            [testId]="'system-config-avatar-upload-overlay'"
                          >
                            <nz-icon nzType="camera" nzTheme="outline" [testId]="'system-config-avatar-camera-icon'" />
                          </div>
                        </div>
                        <div class="upload-hint" [testId]="'system-config-avatar-upload-hint'">{{
                          'system-config.avatar-upload-hint' | i18n
                        }}</div>
                      </div>
                    </ng-container>

                    <!-- 在模板底部添加头像上传模态框 -->
                  </nz-form-control>
                </nz-form-item>
              </ng-container>
            </div>
          </div>
        </nz-card>
      </form>
    </nz-spin>
  </div>
  <div class="form-actions" [testId]="'system-config-form-actions'">
    <div class="actions-container" [testId]="'system-config-actions-container'">
      <button nz-button nzType="primary" (click)="saveConfig()" [nzLoading]="configSaving" [testId]="'system-config-save-button'">{{
        'common.save' | i18n
      }}</button>
      <button nz-button nzType="default" (click)="resetConfig()" [testId]="'system-config-reset-button'">{{
        'system-config.button.reset' | i18n
      }}</button>
    </div>
  </div>
</div>
<avatar-upload-modal
  [(visible)]="isAvatarModalVisible"
  (cancel)="handleAvatarModalCancel()"
  (ok)="handleAvatarCropped($event)"
  [testId]="'system-config-avatar-upload-modal'"
/>
